import { render } from "./IncrementInput.vue?vue&type=template&id=fb449324&scoped=true&ts=true&lang=pug"
import script from "./IncrementInput.vue?vue&type=script&lang=ts"
export * from "./IncrementInput.vue?vue&type=script&lang=ts"

import "./IncrementInput.vue?vue&type=style&index=0&id=fb449324&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb449324"]])

export default __exports__